import {FieldValue, VehicleTypeEnumObject} from '@dms/api/shared';

import type {AdditionalInformationRequestBody} from './AdditionalInformationRequestBody';
import type {BatteryRequestBody} from './BatteryRequestBody';
import type {DimensionsRequestBody} from './DimensionsRequestBody';
import {ElectricVehicleBatteryRequestBody} from './ElectricVehicleBatteryRequestBody';
import type {EngineRequestBody} from './EngineRequestBody';
import type {ModelSpecificationRequestBody} from './ModelSpecificationRequestBody';
import type {StateRequestBody} from './StateRequestBody';
import type {VehiclePhotoRequestBody} from './VehiclePhotoRequestBody';

export type CreateVehicleRequestBody = {
  dimensions: DimensionsRequestBody;
  engine: EngineRequestBody;
  modelSpecification: ModelSpecificationRequestBody;
  state: StateRequestBody;
  additionalInformation?: AdditionalInformationRequestBody | null;
  features?: Array<string>;
  photos?: Array<VehiclePhotoRequestBody>;
  /**
   * Vehicle VIN identificator
   */
  vin?: string | null;
  /**
   * Vehicle manufacturer name
   */
  make: string;
  /**
   * Vehicle model family name
   */
  modelFamily: string;
  externalId?: string | null;
  /**
   * Used if make is MAKE_OTHER
   */
  customMake?: string | null;
  /**
   * Used if make is MAKE_OTHER-MODELFAMILY_OTHER
   */
  customModelFamily?: string | null;
  /**
   * Vehicle trim level, often specifying motorisation or equipment
   */
  trim?: string | null;
  /**
   * Vehicle variant name, such as editions, limited variants or specific types
   */
  variant?: string | null;
  /**
   * Vehicle fuel type
   */
  fuelType?: string | null;
  /**
   * Vehicle hybrid type
   */
  hybridType?: string | null;
  /**
   * Vehicle secondary fuel type
   */
  secondaryFuelType?: string | null;
  /**
   * Vehicle hand drive type
   */
  handDriveType?: string | null;
  /**
   * Vehicle transmission type
   */
  transmission?: string | null;
  /**
   * Vehicle category by door count and layout
   */
  doorCountCategory?: string | null;
  /**
   * Vehicle body style
   */
  bodyStyle?: string | null;
  /**
   * Vehicle drive specification
   */
  drive?: string | null;
  /**
   * Vehicle power in kW
   */
  power?: number | null;
  firstRegistrationOnDay?: number | null;
  firstRegistrationOnMonth?: number | null;
  firstRegistrationOnYear?: number | null;
  manufacturedOnMonth?: number | null;
  manufacturedOnYear?: number | null;
  sellingPrice?: string | null;
  sellingPriceWithVat?: string | null;
  sellingPriceVatRate?: string | null;
  purchasePrice?: string | null;
  purchasePriceWithVat?: string | null;
  purchasePriceVatRate?: string | null;
  currencyCode?: string | null;
  /**
   * Can be VAT deduced by buyer?
   */
  isVatDeductible?: boolean | null;
  /**
   * Is vehicle archived?
   */
  isArchived?: boolean | null;
  type: VehicleTypeEnumObject;
  source?: string | null;
  /**
   * Vehicle title, if null, then default value of make + model + trim + variant will be used.
   */
  title?: string | null;
  battery?: BatteryRequestBody | null;
  axleCount?: number | null;
  europalletStorageSpaces?: number | null;
  featuresByManufacturer?: string | null;
  vehicleSourceCodeId?: string | null;
  hsn?: string | null;
  tsn?: string | null;
  umweltplakette?: string | null;
  customFields?: FieldValue[];
  electricVehicleBattery?: ElectricVehicleBatteryRequestBody | null;
  salePresetId?: string | null;
};
